import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.video-testimonial-slider' ).each( function( index, element ) {
        const splide = new Splide( element, {
          type: 'loop',
          gap: '2rem',
          perMove: 1,
          pagination: false,
          speed: 800,
          fixedWidth: '348px',
          breakpoints: {
            768: {
              fixedWidth: false,
              perPage: 1,
            },
          },
        } ).mount( {} );

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'video-testimonial-slider', COMPONENT );
} )( app );
